// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__BKhgK","title":"Footer_title__7DRaa","content":"Footer_content__9IL8y","infoSection":"Footer_infoSection__3YeSb"};